// Render fragment for of — the entity's GraphQL display contract.
// Scaffolded once from the @medplum/definitions reverse projection; hand-curate
// freely to match what the view renders (this file is owned, not generated).
import { graphql } from '@eluve/graphql-fhir';

/**
 * Everything a Goal view (or the generic fallback) could render.
 * Compose into queries: graphql(`query { ... ...GoalRender }`, [GoalRenderFragment]).
 * References are terminal ({ reference type display }) — expand nested
 * `resource` selections in the query when resolved targets are needed.
 */
export const GoalRenderFragment = graphql(`
  fragment GoalRender on Goal @_unmask {
    resourceType
    id
    meta {
      versionId
      lastUpdated
      profile
      tag {
        system
        code
      }
      security {
        system
        code
        display
      }
    }
    modifierExtension {
      url
    }
    extension {
      url
      valueDecimal
    }
    identifier {
      use
      system
      value
    }
    lifecycleStatus
    achievementStatus {
      text
      coding {
        system
        code
        display
      }
    }
    category {
      text
      coding {
        system
        code
        display
      }
    }
    priority {
      text
      coding {
        system
        code
        display
      }
    }
    description {
      text
      coding {
        system
        code
        display
      }
    }
    subject {
      reference
      type
      display
    }
    startDate
    target {
      measure {
        text
        coding {
          system
          code
          display
        }
      }
      detailQuantity {
        value
        comparator
        unit
        system
        code
      }
      detailRange {
        low {
          value
          comparator
          unit
          system
          code
        }
        high {
          value
          comparator
          unit
          system
          code
        }
      }
      detailString
      dueDate
      dueDuration {
        value
        unit
        system
        code
      }
    }
    statusDate
    statusReason
    expressedBy {
      reference
      type
      display
    }
    addresses {
      reference
      type
      display
    }
    note {
      authorReference {
        reference
        type
        display
      }
      authorString
      time
      text
    }
  }
`);
